import React from "react";
import { PageHero } from "../components/site/Shared";
import { Reveal } from "../components/site/Reveal";
import { PrimaryButton } from "../components/site/Buttons";
import { CAPABILITIES } from "../data/content";

export default function Capabilities() {
  return (
    <div data-testid="capabilities-page">
      <PageHero
        eyebrow="Capabilities"
        titleLines={["Advisory designed", "around the moment."]}
        lede="Yadid's capabilities are not isolated services. They are different ways of helping leaders understand, navigate, and move through consequential situations."
      />

      <section className="bg-ivory">
        <div className="yadid-container">
          {CAPABILITIES.map((c, i) => (
            <div
              key={c.slug}
              data-testid={`capability-${c.slug}`}
              className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 py-16 md:py-24 border-b border-stone"
            >
              <div className="lg:col-span-4">
                <Reveal>
                  <span className="font-serif text-brass text-2xl">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-[-0.02em] text-ink">
                    {c.title}
                  </h2>
                </Reveal>
              </div>
              <div className="lg:col-span-7 lg:col-start-6">
                <Reveal delay={0.1}>
                  <p className="font-serif text-2xl md:text-3xl text-ink/85 italic leading-snug">
                    {c.headline}
                  </p>
                  <p className="mt-8 text-lg text-ink/70 font-light leading-relaxed">{c.body}</p>
                  <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
                    {c.list.map((item) => (
                      <li key={item} className="flex gap-3 items-baseline text-ink/70 font-light">
                        <span className="text-brass text-xs">&#9679;</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="mt-8 text-ink/60 font-light leading-relaxed border-l-2 border-brass pl-6">
                    {c.note}
                  </p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Closing */}
      <section className="bg-ink text-ivory">
        <div className="yadid-container py-28 md:py-40">
          <div className="max-w-4xl">
            <Reveal>
              <p className="eyebrow text-brass mb-8">Begin With the Situation</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-[-0.02em] text-ivory">
                The engagement begins with the situation, not the service.
              </h2>
              <p className="mt-8 text-lg text-ivory/70 font-light leading-relaxed max-w-2xl">
                Tell us what you are navigating. We can determine together what kind of advisory
                relationship would be most useful.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-12">
                <PrimaryButton
                  to="/contact"
                  data-testid="capabilities-closing-cta"
                  className="!bg-brass !text-ink hover:!bg-[#d9bd93]"
                >
                  Start a Conversation
                </PrimaryButton>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
